// extracted by mini-css-extract-plugin
module.exports = {"l17lpp8k":"l17lpp8k","d16kq653":"d16kq653"};